import React from 'react';
import MainCard from "src/components/material/Cards/MainCard";
import SubCard from 'src/components/material/Cards/SubCard';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import EditUserSettings from './EditUserSettings';
import { useTranslation } from 'react-i18next';
import ChangePassword from './ChangePassword';
import ChangeLanguageSettings from './ChangeLanguageSettings';


const UserSettingsDashboard = (props) => {
    const { t } = useTranslation();

    return (
        <MainCard title={t("Profile Settings")} sx={{}}>
            <Grid container spacing={2} sx={{ mb: 2 }} justifyContent={"center"}>
                <Grid xs={12} md={6}>
                    <SubCard title={t("Edit Account Information")} darkTitle>
                        <EditUserSettings />
                    </SubCard>
                </Grid>
                <Grid xs={12} md={4}>
                    <SubCard title={t("Change Password")} darkTitle>
                        <ChangePassword />
                    </SubCard>
                    <SubCard title={t("Portal Settings")} darkTitle sx={{ marginTop: 2 }}>
                        <ChangeLanguageSettings />
                    </SubCard>
                </Grid>
                <Grid xs={12} md={4}>

                </Grid>
            </Grid>
        </MainCard>
    );
};

export default UserSettingsDashboard;
